var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-type"},[_c('button',{staticClass:"btn-link",on:{"click":function($event){return _vm.limitOrd(_vm.params)}}},[_vm._v("지정가")]),_c('button',{staticClass:"btn-link",on:{"click":function($event){return _vm.maketOrd(_vm.params)}}},[_vm._v("시장가")])])
}
var staticRenderFns = []

export { render, staticRenderFns }